module.exports = __webpack_public_path__ + "img/check-bgimg.111abaa2.png";